import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { IPIValidator } from '@App/helpers/validate'
import SearchResult from '@Components/WorkRegistrationSubs/SearchResult'
import { PublisherModelWithWorksCount } from '@Entities/work/publisher-model-with-works-count'
import { PublisherSearchStoreLike } from '@App/stores/search/publisher-search-store-like'

interface PublisherSearchResultsTableProps {
    suggestedTitle?: string
    itemWasAdded?: (publisherName: string) => boolean | undefined
    setFoundPublisherToDraft: (publisher: PublisherModelWithWorksCount) => void
    showMLCPublisherNumber?: boolean
    buttonText?: string
    searchStore?: PublisherSearchStoreLike
}

const PublisherSearchResultsTable = ({
    suggestedTitle,
    itemWasAdded,
    setFoundPublisherToDraft,
    showMLCPublisherNumber,
    buttonText,
    searchStore,
}: PublisherSearchResultsTableProps) => {
    const { publisherSearchStore } = useContext<RootStore>(StoresContext)

    const resolvedSearchStore = searchStore ?? publisherSearchStore
    const searchResult = resolvedSearchStore.publisherSearchModel

    const isValidIPI = (ipiNumber: string | null) => (ipiNumber ? IPIValidator(ipiNumber, true) : true)

    const publisherRoles = (model: PublisherModelWithWorksCount) => {
        const roles = []
        if (isValidIPI(model.ipiNumber) && model.ipiNumber) {
            roles.push({ name: 'IPI', value: model.ipiNumber })
        }

        if (showMLCPublisherNumber && model.hfaPublisherNumber) {
            roles.push({ name: 'Publisher Number', value: model.hfaPublisherNumber })
        }

        return roles
    }

    return (
        <>
            {suggestedTitle && <p className="suggested-title">{suggestedTitle}</p>}
            <div className="suggested">
                {searchResult.results.map(({ entity }, index) => (
                    <SearchResult
                        key={entity.ipId ?? index}
                        title={entity.publisherName}
                        onAddClicked={() => setFoundPublisherToDraft(entity)}
                        onItemWasAdded={itemWasAdded}
                        roles={publisherRoles(entity)}
                        addButtonText={buttonText}
                    />
                ))}
            </div>
        </>
    )
}

export default observer(PublisherSearchResultsTable)
